import React from 'react';
import styled from 'styled-components';

function Landing(props) {
  return (
    <Wrapper>
      <h2>Welcome to rev.sdk.js!</h2>
      <p>The best choice for your next e-commerce project</p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 20px;
`;

export default Landing;
